import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, Divider, Grid, Stack } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import Helpers from "../../helpers/helpers";
import "./advert.css";
import CustomButton from "../../components/Form/CustomButton";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton";
import CustomTextField from "../../components/Form/CustomTextField";
import ImportantNotice from "../../components/Common/ImportantNotice";
import TableStyle2 from "../../components/Common/TableStyle2";
import Toggle from "../../components/Common/Toggle";
import VehicleDetailsModal from "./modal/VehicleDetails";
import AppDialog from "../../components/Common/AppDialog";
import MarkSold from "./modal/MarkSold";
import MarkReserved from "./modal/MarkReserved";
import ReactivateAlert from "./modal/ReactivateAlert";
import BoostAdvert from "./modal/BoostAdvert";
import RenewAdvert from "./modal/RenewAdvert";
import TablePageControl from "../../components/Common/TablePageControl";
import MoveDraft from "./modal/MoveDraft";
import { deleteAdvert, getAdvertDetails, getAdvertInquiryListing, getAdvertRemarkListing, resetAdvertActionState, resetAdvertState, updateAdvert, verify_admin } from "../../store/actions";
import PublishAdvert from "./modal/PublishAdvert";
import RevertStatus from "./modal/RevertStatus";
import MoveToHidden from "./modal/MoveToHidden";
import AppealModal from "./modal/AppealModal";


const AdvertDetails = ({ title, userPermission, advertDetails, leftSideBarType, advertRemarkListing, advertInquiryListing, makeList, modelList, editAdvert, bodyList, licenseCategoryList, salesmanList, advertDelete,
    userCreditBalance, width, transmissionList, error, isDirectSeller, advertDetailsCode
}) => {
    const { ID } = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(resetAdvertState());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [loading, setIsLoading] = useState(false);
    const [remark, setRemark] = useState();
    const [creatable, setCreatable] = useState(true);
    const [editable, setEditable] = useState(true);
    const [exportable, setExportable] = useState(true);
    const [deletable, setDeletable] = useState(true);
    const [vehicleDetailsOpen, setVehicleDetailsOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [soldOpen, setSoldOpen] = useState(false);
    const [reservedOpen, setReservedOpen] = useState(false);
    const [reactivateAlertOpen, setReactivateAlertOpen] = useState(false);
    const [boostOpen, setBoostOpen] = useState(false);
    const [renewOpen, setRenewOpen] = useState(false);
    const [appealOpen, setAppealOpen] = useState(false);
    const [revertOpen, setRevertOpen] = useState(false);
    const [revertStatus, setRevertStatus] = useState('');
    const [moveDraftOpen, setMoveDraftOpen] = useState(false);
    const [moveToHiddenOpen, setMoveToHiddenOpen] = useState(false);
    const [publishOpen, setPublishOpen] = useState(false);
    const [inquiryPage, setInquiryPage] = useState(1);
    const [inquiryLength, setInquiryLength] = useState(10);
    const [remarkPage, setRemarkPage] = useState(1);
    const [remarkLength, setRemarkLength] = useState(10);
    const [isImportantNoticeOpen, setIsImportantNoticeOpen] = useState(true);
    const [isFeaturedAdvert, setIsFeaturedAdvert] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-user") && setCreatable(true);
            userPermission?.includes("update-user") && setEditable(true);
            userPermission?.includes("export-user") && setExportable(true);
            userPermission?.includes("delete-user") && setDeletable(true);
        }
    }, [userPermission])

    useEffect(() => {
        if (editAdvert?.code === 'success') {
            setNotification({
                open: true,
                type: 'success',
                msg: 'Advert updated successfully.'
            });
            initData();
            initRemarkData();
            remark && setRemark('');
            soldOpen && setSoldOpen(false);
            reservedOpen && setReservedOpen(false);
            publishOpen && setPublishOpen(false);
            moveDraftOpen && setMoveDraftOpen(false);
            renewOpen && setRenewOpen(false);
            revertOpen && setRevertOpen(false);
            boostOpen && setBoostOpen(false);
            moveToHiddenOpen && setMoveToHiddenOpen(false);
            appealOpen && setAppealOpen(false);
            dispatch(resetAdvertActionState());
        } else if (editAdvert?.code === 'invalid_field') {
            setIsLoading(false);
            setNotification({
                open: true,
                type: 'error',
                msg: editAdvert?.errors?.action?.[0] || 'Please check the form and try again.'
            });
            dispatch(resetAdvertActionState());
        }
    }, [editAdvert])

    useEffect(() => {
        if (ID) {
            initData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ID]);

    useEffect(() => {
        initRemarkData();
    }, [ID, remarkPage, remarkLength]);

    useEffect(() => {
        initInquiryData();
    }, [ID, inquiryPage, inquiryLength]);

    useEffect(() => {
        if (advertDetails?.id) {
            setIsLoading(false);
            setIsFeaturedAdvert(advertDetails?.is_featured === 1 ? true : false);
        }
    }, [advertDetails]);

    useEffect(() => {
        if (advertDetailsCode?.code && advertDetailsCode?.code !== 'success') {
            setIsLoading(false);
        }
    }, [advertDetailsCode]);

    useEffect(() => {
        if (advertDelete?.code === 'success') {
            setNotification({ open: true, msg: advertDelete?.message || 'Advert deleted successfully', type: 'success' });
            setTimeout(() => {
                setIsLoading(false);
                dispatch(resetAdvertActionState());
                navigate('/advert');
            }, 2000);

        }
    }, [advertDelete])

    const header = [
        {
            title: 'Date of Inquiry',
            accessor: (item, idx) => {
                return (item?.created_at || '-')
            }
        },
        {
            title: 'User Name',
            accessor: (item, idx) => {
                return (item?.requestor?.name || '-')
            }
        },
        {
            title: 'Contact',
            accessor: (item, idx) => {
                return (item?.requestor?.phone || '-')
            }
        },
        {
            title: 'Inquiries Status',
            accessor: (item, idx) => {
                return (<Label.GeneralStatusLabel label={item?.status} list={Helpers.invoiceStatus} marginLeft={"0px"} />)
            }
        },
        {
            title: ' ',
            width: 250,
            accessor: (item, idx) => {
                return (
                    <>
                        {
                            item?.requestor?.whatsapp_url ?
                                <CustomButton
                                    title={
                                        <div className="d-flex align-items-center" style={{ color: 'white' }}>
                                            <Icon icon={'mingcute:whatsapp-fill'} style={{ marginRight: 10 }} />Contact Buyer
                                        </div>
                                    }
                                    press={() => window.open(item?.requestor?.whatsapp_url, '_blank')} // link to whatsapp chat
                                    textColor={'white'}
                                    backgroundColor={'#59C825'}
                                />
                                : null
                        }
                    </>
                )
            }
        },
    ]

    const remarkHeader = [
        {
            title: 'Date',
            accessor: (item, idx) => {
                return (item?.created_at || '-')
            }
        },
        {
            title: 'Remark / Notes',
            width: '50%',
            accessor: (item, idx) => {
                return (item?.remark || '-')
            }
        },
        {
            title: 'Action By',
            accessor: (item, idx) => {
                return (item?.action_by || '-')
            }
        },
    ]

    const draftDropdown = [
        { iconName: 'solar:upload-minimalistic-linear', label: 'Publish', color: '#1D1B1B', onClick: () => { setPublishOpen(true) } },
        { iconName: 'solar:eye-linear', label: 'View Details', permission: true, onClick: () => { setVehicleDetailsOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Draft', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ]

    const publishedDropdown = [
        { iconName: 'solar:rocket-2-linear', label: 'Boost', subLabel: `${advertDetails?.remaining_boosters || 0}/3`, permission: editable, onClick: () => { setBoostOpen(true); dispatch(verify_admin()) } },
        { iconName: 'solar:check-read-linear', label: 'Mark as Sold', permission: editable, onClick: () => { setSoldOpen(true) } },
        { iconName: 'fluent:door-tag-20-regular', label: 'Mark as Reserved', permission: editable, onClick: () => { setReservedOpen(true) } },
        { iconName: 'solar:refresh-linear', label: 'Renew', permission: editable, onClick: () => { setRenewOpen(true) } },
        { iconName: 'solar:eye-linear', label: 'View Details', permission: true, onClick: () => { setVehicleDetailsOpen(true) } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { setMoveToHiddenOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ]

    const expiredDropdown = [
        { iconName: 'solar:refresh-linear', label: 'Renew', permission: editable, onClick: () => { setRenewOpen(true) } },
        { iconName: 'solar:eye-linear', label: 'View Details', permission: true, onClick: () => { setVehicleDetailsOpen(true) } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { setMoveToHiddenOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ]

    const reservedDropdown = [
        { iconName: 'solar:check-read-linear', label: 'Mark as Sold', permission: editable, onClick: () => { setSoldOpen(true) } },
        { iconName: 'solar:undo-left-round-linear', label: 'Revert to Published', permission: deletable, onClick: () => { setRevertStatus('published'); setRevertOpen(true) } },
        { iconName: 'solar:eye-linear', label: 'View Details', permission: true, onClick: () => { setVehicleDetailsOpen(true) } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { setMoveToHiddenOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ]

    const soldDropdown = [
        { iconName: 'fluent:door-tag-20-regular', label: 'Mark as Reserved', permission: editable, onClick: () => { setReservedOpen(true) } },
        { iconName: 'solar:undo-left-round-linear', label: 'Revert to Published', permission: deletable, onClick: () => { setRevertStatus('published'); setRevertOpen(true) } },
        { iconName: 'solar:eye-linear', label: 'View Details', permission: true, onClick: () => { setVehicleDetailsOpen(true) } },
        { iconName: 'formkit:hidden', label: 'Set as Hidden', color: '#1D1B1B', permission: editable, onClick: () => { setMoveToHiddenOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ]

    const hiddenDropdownList = [
        { iconName: 'solar:undo-left-round-linear', label: 'Revert to Published', permission: deletable, onClick: () => { setRevertStatus('published'); setRevertOpen(true) } },
        { iconName: 'fluent:door-tag-20-regular', label: 'Mark as Reserved', permission: editable, onClick: () => { setReservedOpen(true) } },
        { iconName: 'solar:check-read-linear', label: 'Mark as Sold', permission: editable, onClick: () => { setSoldOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ]

    const defaultDropdown = [
        { iconName: 'solar:eye-linear', label: 'View Details', permission: true, onClick: () => { setVehicleDetailsOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ]
    const rejectedDropdown = [
        { iconName: 'ri-draft-line', label: 'Appeal', permission: true, onClick: () => { setAppealOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ]

    const initData = () => {
        dispatch(resetAdvertState());
        dispatch(getAdvertDetails({ id: ID }));
    }

    const initRemarkData = () => {
        dispatch(getAdvertRemarkListing({ id: ID, page: remarkPage, length: remarkLength }));
    }

    const initInquiryData = () => {
        dispatch(getAdvertInquiryListing({ id: ID, page: inquiryPage, length: inquiryLength }));
    }

    const handleSubmitRemark = () => {
        if (!remark) {
            setNotification({
                open: true,
                type: 'error',
                msg: 'Please enter remark before submitting.'
            });
            return;
        }
        setIsLoading(true);
        dispatch(updateAdvert({
            id: advertDetails?.id,
            data: {
                action: 'add_remark',
                remark: remark
            }
        }))
    }

    const handleUpdateFeaturedAdvert = (checked) => {
        setIsLoading(true);
        dispatch(updateAdvert({
            id: advertDetails?.id,
            data: { action: "toggle_feature", is_featured: checked ? 1 : 0 }
        }));
    }

    const handleDelete = () => {
        setIsLoading(true);
        dispatch(deleteAdvert({ ids: [advertDetails?.id] }));
    }

    const handleMarkAsSold = () => {
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            status: 'sold'
        }
        dispatch(updateAdvert({ id: advertDetails?.id, data: payload }))
    }

    const handleAppeal = () => {
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            status: 'appealed'
        }
        dispatch(updateAdvert({ id: advertDetails?.id, data: payload }))
    }
    const handleMoveToHidden = () => {
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            status: 'hidden'
        }
        dispatch(updateAdvert({ id: advertDetails?.id, data: payload }))
    }

    const handleMarkAsReserved = () => {
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            status: 'reserved'
        }
        dispatch(updateAdvert({ id: advertDetails?.id, data: payload }))
    }

    const handleReactivateAlert = () => {
        setIsLoading(true);
    }

    const handleBoostAdvert = () => {
        setIsLoading(true);
        let payload = {
            action: 'boost_advert',
        }
        dispatch(updateAdvert({ id: advertDetails?.id, data: payload }))
    }

    const handleRenewAdvert = () => {
        setIsLoading(true);
        let payload = {
            action: 'renew_plan',
        }
        dispatch(updateAdvert({ id: advertDetails?.id, data: payload }))
    }

    const handlePublish = () => {
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            status: 'published'
        }
        dispatch(updateAdvert({ id: advertDetails?.id, data: payload }))
    }

    const handleMoveToDraft = () => {
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            status: 'draft'
        }
        dispatch(updateAdvert({ id: advertDetails?.id, data: payload }))
    }

    const handleRevertStatus = () => {
        setIsLoading(true);
        let payload = {
            action: 'update_status',
            status: revertStatus
        }
        dispatch(updateAdvert({ id: advertDetails?.id, data: payload }))
    }
    const content =
        advertDetails?.status === 'pending_approval' || advertDetails?.status === 'pending' ? {
            title: 'Your advert has been submitted and is awaiting admin review.',
            description: 'You will be notified once it’s approved or if any changes are required.',
            iconName: 'solar:clock-circle-linear',
            backgroundColor: '#F0F0F0',
            borderColor: '#1D1B1B',
            iconColor: '#1D1B1B',
            hasActionButton: false,
        } :
            advertDetails?.status === 'published' && parseInt(advertDetails?.expiry_in, 10) <= 14 ? {
                title: 'Your Advert Is Nearing Expiry',
                description: (
                    <>
                        This advert will expire in <span className="text-bold">{advertDetails?.expiry_in}</span>. Renewing will require <span className="text-bold">{advertDetails?.advert_plan?.credit_required}</span>. Make sure you have enough credits to proceed.
                    </>
                ), iconName: 'solar:danger-triangle-linear',
                backgroundColor: '#F4C06D33',
                borderColor: '#F4C06D',
                iconColor: '#1D1B1B',
                hasActionButton: true,
            } :
                advertDetails?.status === 'expired' ? {
                    title: 'This advert has expired and is no longer visible to buyers.',
                    description: `You can renew the advert to make it active again.`,
                    iconName: 'solar:danger-triangle-linear',
                    backgroundColor: '#FFE9E9',
                    borderColor: '#D13536',
                    iconColor: '#D13536',
                    hasActionButton: true,
                } :
                    advertDetails?.status === 'sold' ? {
                        title: 'You’ve marked this advert as sold.',
                        description: `This listing is no longer visible to buyers.`,
                        iconName: 'ri:check-line',
                        backgroundColor: '#34C75926',
                        borderColor: '#11812E',
                        iconColor: '#11812E',
                        hasActionButton: false,
                    } : ""

    const renderNoticeSection = () => {
        if (!content || !isImportantNoticeOpen) return null;
        return (
            <ImportantNotice
                backgroundColor={content?.backgroundColor}
                color={content?.borderColor}
                iconColor={content?.iconColor}
                iconName={content?.iconName}
                message={
                    <>
                        <div className="text-bold mb-2" style={{ color: content?.iconColor }}>{content?.title}</div>
                        {content?.description && <div style={{ color: content?.iconColor }}>{content?.description}</div>}

                        {
                            content?.hasActionButton &&
                            <Box className="mt-3 align-items-center" sx={{ display: { lg: 'flex', md: 'block' }, marginTop: { md: 2, sm: 2, xs: 2 } }}>
                                <CustomButton
                                    title={'Renew Now'}
                                    press={() => { setRenewOpen(true) }}
                                    marginRight={10}
                                />
                                <CustomButton
                                    title={'Dismiss'}
                                    press={() => { setIsImportantNoticeOpen(false) }}
                                    backgroundColor={'#F9F9F9'}
                                    textColor={'#1D1B1B'}
                                    borderStyle={'1px solid #F9F9F9'}
                                    marginTop={width <= 375 ? 5 : 0}
                                />
                            </Box>
                        }
                    </>
                }
            />
        )
    }

    const renderPricingContent = () => {
        return (
            <>
                {/* {
                    advertDetails?.pricing?.pricing_type === 1 && //machine price
                    <div className="d-flex align-items-center my-2">
                        <span className="price-text">${advertDetails?.pricing?.machine_price || 0}</span>
                        <span className="subheader-2 mx-2">
                            Instl. <span style={{ fontWeight: 400, color: '#101010' }}>${advertDetails?.pricing?.monthly_instalment || 0}</span>/mth
                        </span>
                    </div>
                }
                {
                    advertDetails?.pricing?.pricing_type === 2 && //downpayment
                    <>
                        <span className="price-text">${advertDetails?.pricing?.min_downpayment || 0}</span>
                        <div className="subheader-2 mb-2">
                            Instl. <span style={{ fontWeight: 400, color: '#101010' }}>${advertDetails?.pricing?.monthly_instalment || 0}</span>/mth <span className="mx-1">{'\u2022'}</span>
                            <span className="mx-2">{`Price $${advertDetails?.pricing?.machine_price || 0}`}</span>
                        </div>
                    </>
                }
                {
                    advertDetails?.pricing?.pricing_type === 3 && //promotion
                    <>
                        <span className="price-text">${advertDetails?.pricing?.promotion_price || 0}</span>
                        <div className="subheader-2 mb-2">
                            Instl. <span style={{ fontWeight: 400, color: '#101010' }}>${advertDetails?.pricing?.monthly_instalment || 0}</span>/mth <span className="mx-1">{'\u2022'}</span>
                            <span className="mx-2">{`Dp. `}$<span style={{ fontWeight: 400, color: '#101010' }}>{advertDetails?.pricing?.min_downpayment || 0}</span></span>
                        </div>
                    </>
                } */}
                {/* {
                    advertDetails?.pricing?.pricing_type === 4 && // selling price */}
                <>
                    <span className="price-text">${advertDetails?.pricing?.price_formatted || 0}</span>
                    {!isDirectSeller && <div className="subheader-2 mb-2">
                        Instl. <span style={{ fontWeight: 400, color: '#101010' }}>${advertDetails?.pricing?.monthly_instalment_formatted || 0}</span>/mth <span className="mx-1">{'\u2022'}</span>
                        <span className="mx-2">{`Dp. `}<span style={{ fontWeight: 400, color: '#101010' }}>${advertDetails?.pricing?.min_downpayment_formatted || 0}</span></span>
                    </div>}
                </>
                {/* } */}
            </>
        )
    }

    const renderRentPriceContent = () => {
        return (
            <>
                <div className="d-flex align-items-end mt-2">
                    <span className="price-text">${advertDetails?.rental_rate?.daily_rate_formatted || 0}</span>
                    <div className="subheader-2 mx-2" style={{ fontWeight: 400 }}> / day</div>
                </div>
                <Stack flexDirection={'row'} gap={1} mb={1}>
                    <div className="d-flex align-items-center">
                        ${advertDetails?.rental_rate?.weekend_rate_formatted || 0}
                        <div className="subheader-2 mx-1">weekend ,</div>
                    </div>
                    <div className="d-flex align-items-center">
                        ${advertDetails?.rental_rate?.['3_days_rate_formatted'] || 0}
                        <div className="subheader-2 mx-1">for 3 days,</div>
                    </div>
                    <div className="d-flex align-items-center">
                        ${advertDetails?.rental_rate?.weekly_rate_formatted || 0}
                        <div className="subheader-2 mx-1">weekly,</div>
                    </div>
                    <div className="d-flex align-items-center">
                        ${advertDetails?.rental_rate?.monthly_rate_formatted || 0}
                        <div className="subheader-2 mx-1">monthly</div>
                    </div>
                </Stack>
            </>
        )
    }

    const renderGeneralTab = () => {
        const makeName = makeList?.find((item) => item.id === advertDetails?.bike_make_id)?.name || '-';
        const modelName = modelList?.find((item) => item.id === advertDetails?.bike_model_id)?.name || '-';
        return (
            <>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item lg={7} md={12} sm={12}>
                                        <div className="header">
                                            {advertDetails?.info?.title}
                                        </div>
                                    </Grid>
                                    <Grid item lg={5} md={12} sm={12} display={'flex'} alignItems={'center'} sx={{ justifyContent: { lg: 'end', md: 'start' } }}>
                                        <Stack sx={{ display: 'flex', flexDirection: { lg: 'row', md: 'block' }, justifyContent: { lg: 'end', md: 'start' }, gap: 2 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }} gap={2}>
                                                {
                                                    (advertDetails?.is_synced === 1 && advertDetails?.status !== 'draft' && advertDetails?.status !== 'pending_approval' && advertDetails?.status !== 'pending' && advertDetails?.status !== 'rejected' && advertDetails?.status !== 'suspended') &&
                                                    <CustomButton
                                                        title={<><span style={{ display: 'inline-flex', alignItems: 'center' }}><span style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><Icon icon="solar:square-top-down-linear" style={{ fontSize: 18 }} /></span>View on Marketplace</span></>}
                                                        backgroundColor="#F5F5F5"
                                                        textColor="#1D1B1B"
                                                        borderStyle="1px solid #F5F5F5"
                                                        press={() => {
                                                            if (advertDetails?.is_synced == 1) {
                                                                window.open(advertDetails?.marketplace_url || `/marketplace/advert/${advertDetails?.id}`, '_blank')
                                                            } else {
                                                                dispatch(getAdvertDetails({ id: ID }));
                                                                setNotification({
                                                                    open: true,
                                                                    type: 'error',
                                                                    msg: (
                                                                        <>
                                                                            <b>Your Listing Is Coming Soon</b><br />
                                                                            We're still getting your advert ready. Please wait a moment and check back later to view your listing page.
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        }}
                                                        marginRight={10}
                                                    // press={() => window.open(advertDetails?.marketplace_url, '_blank')}

                                                    />
                                                }
                                                {
                                                    // (advertDetails?.status !== 'pending_approval' && advertDetails?.status !== 'pending') &&
                                                    <CustomButton
                                                        title={<><span style={{ display: 'inline-flex', alignItems: 'center' }}><span style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><Icon icon="solar:pen-linear" style={{ fontSize: 18 }} /></span>Edit Vehicle</span></>}
                                                        backgroundColor="white"
                                                        textColor="#1D1B1B"
                                                        borderStyle="1px solid #1D1B1B"
                                                        press={() => { navigate(`/edit-advert/${ID}`) }}
                                                    />
                                                }
                                                {
                                                    // (advertDetails?.status !== 'pending_approval' && advertDetails?.status !== 'pending') &&
                                                    <RenderPopOverButton
                                                        items={
                                                            advertDetails?.status === 'draft' ? draftDropdown :
                                                                advertDetails?.status === 'published' ? publishedDropdown :
                                                                    advertDetails?.status === 'reserved' ? reservedDropdown :
                                                                        advertDetails?.status === 'sold' ? soldDropdown :
                                                                            advertDetails?.status === 'expired' ? expiredDropdown :
                                                                                advertDetails?.status === 'hidden' ? hiddenDropdownList :
                                                                                    advertDetails?.status === 'rejected' && isDirectSeller ? rejectedDropdown :
                                                                                        defaultDropdown
                                                        }
                                                    />
                                                }
                                            </Box>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                {
                                    // advertDetails?.status === 'published' && advertDetails?.is_near_expiry === 1 &&
                                    renderNoticeSection()
                                }
                            </Grid>
                            <Grid item container md={12} sm={12} xs={12} mt={(!content || !isImportantNoticeOpen) ? 0 : 2}>
                                <Grid item lg={2} md={2} sm={12} xs={12} className="subheader-2 p-2">
                                    <img src={advertDetails?.images?.find((item) => item?.type === 'thumbnail')?.base64 || Helpers.noImage} style={{ width: '100%', height: 120, objectFit: 'contain' }} />
                                </Grid>
                                <Grid item lg={10} md={10} sm={12} xs={12} py={2} px={1}>
                                    <div className="text-bold font-size-18">{makeName || '-'} {modelName || ''}</div>
                                    {
                                        advertDetails?.bike_advert_type === 'rental' ?
                                            renderRentPriceContent()
                                            :
                                            renderPricingContent()
                                    }
                                    <Stack flexDirection={'row'} gap={1.5} mt={1} flexWrap={'wrap'} alignItems={'center'}>
                                        <div className="d-flex align-items-center flex-row">
                                            <Label.GeneralStatusLabel label={advertDetails?.bike_advert_type} list={[{ label: Helpers.capitalize(advertDetails?.bike_advert_type || ''), value: advertDetails?.bike_advert_type, statusColor: 'light-grey' }]} marginLeft={"0px"} />
                                            <Label.GeneralStatusLabel label={advertDetails?.status} list={Helpers.advertStatus} />

                                        </div>
                                        <div className="">
                                            <span className="subheader-2">Advert ID: </span>
                                            {advertDetails?.display_id || '-'}
                                        </div>
                                        <div className="d-flex align-items-center gap-3">
                                            <div>
                                                <span className="subheader-2">Listed On: </span>
                                                {advertDetails?.created_at || '-'}
                                            </div>
                                            <div>
                                                <span className="subheader-2">Expired At: </span>
                                                {advertDetails?.expired_date || '-'}
                                            </div>
                                        </div>
                                    </Stack>
                                </Grid>
                            </Grid>
                            <Grid item sm={12}>
                                {renderAdvertInfo()}
                            </Grid>
                            {/* advertDetails?.status - published */}
                            {
                                advertDetails?.status === 'published' &&
                                <Grid item sm={12}>
                                    <Toggle
                                        checked={isFeaturedAdvert}
                                        label="Feature this ad"
                                        onChange={(e) => handleUpdateFeaturedAdvert(e.target.checked)}
                                    />
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                    {renderTableSection()}
                </Grid>
            </>
        )
    }

    const renderAdvertInfo = () => {
        return (
            <Box className="advert-info-container">
                <Grid container spacing={2}>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <div className="subheader-2">Total Views</div>
                        <div>{advertDetails?.total_views || '0'}</div>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <div className="subheader-2">WhatsApp Clicks / Inquiries</div>
                        <div>{advertDetails?.total_inquiries || '0'}</div>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <div className="subheader-2">Total Likes</div>
                        <div>{advertDetails?.total_likes || '0'}</div>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <div className="subheader-2">Total Boosts</div>
                        <div>{advertDetails?.boosted_times || '0'}</div>
                    </Grid>
                </Grid>
            </Box>
        )
    }

    const renderTableSection = () => {
        return (
            <>
                <Grid item xs={12} pt={1}>
                    <div className="text-bold font-size-16 pb-4 d-flex align-items-center" >
                        Inquiries ({advertInquiryListing?.data?.length || 0})
                    </div>
                    <TableStyle2
                        header={header}
                        tableData={advertInquiryListing?.data || []}
                    />
                    <TablePageControl
                        length={inquiryLength}
                        setLength={setInquiryLength}
                        page={inquiryPage}
                        setPage={setInquiryPage}
                        totalPage={1}
                    />
                </Grid>
                <Grid item xs={12} mt={3}>
                    <div className="text-bold font-size-16 pb-4 d-flex align-items-center" >
                        Remarks / Notes
                    </div>
                    <TableStyle2
                        header={remarkHeader}
                        tableData={advertRemarkListing?.data || []}
                    />
                    <TablePageControl
                        length={remarkLength}
                        setLength={setRemarkLength}
                        page={remarkPage}
                        setPage={setRemarkPage}
                        totalPage={advertRemarkListing?.last_page || 1}
                    />
                    <div className="mt-3">
                        <CustomTextField
                            values={remark}
                            placeholder={"Remarks / Notes"}
                            onChange={(e) => setRemark(e)}
                            multiline={true}
                            rows={4}
                        />
                    </div>
                    <CustomButton
                        title={'Submit'}
                        press={() => handleSubmitRemark()}
                        marginTop={10}
                    />
                </Grid>
            </>
        )
    }
    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: width <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading || !advertDetailsCode?.code} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} errors={error} />
                    {advertDetailsCode?.code && advertDetailsCode?.code !== "success" ?
                        <div className="d-flex align-items-center justify-content-center" style={{ height: '70vh' }}>
                            <div className="text-center">
                                <div className="header-2 pb-3">{advertDetailsCode?.message || "Something went wrong."}</div>
                                <CustomButton
                                    title={'Go to Listing'}
                                    press={() => navigate('/advert')}
                                    padding={20}
                                />
                            </div>
                        </div>
                        :
                        <Grid container spacing={2}>
                            <Grid item sm={12}>
                                <CustomButton
                                    title={
                                        <div className="d-flex align-items-center" style={{ fontWeight: 400 }}>
                                            <Icon icon={'fluent:chevron-left-20-regular'} style={{ marginRight: 10 }} />Back to listing
                                        </div>
                                    }
                                    borderRadius={"5px"}
                                    borderStyle={"0px"}
                                    backgroundColor={"transparent"}
                                    textColor={"#000000"}
                                    paddingInline={7}
                                    press={() => navigate("/advert")}
                                />
                            </Grid>
                            <Grid item xs={12} pr={0} mr={0}>
                                <div className="px-2">{renderGeneralTab()}</div>
                            </Grid>
                        </Grid>
                    }
                </Container>
                <VehicleDetailsModal
                    open={vehicleDetailsOpen}
                    close={() => setVehicleDetailsOpen(false)}
                    handleSubmit={() => { }}
                    windowWidth={width}
                    vehicleDetails={advertDetails}
                    makeList={makeList}
                    modelList={modelList}
                    bodyList={bodyList}
                    licenseCategoryList={licenseCategoryList}
                    salesmanList={salesmanList}
                    transmissionList={transmissionList}
                    isDirectSeller={isDirectSeller}
                />
                <AppDialog
                    open={deleteOpen}
                    close={() => setDeleteOpen(false)}
                    title={`Delete ${advertDetails?.status === 'draft' ? 'Draft' : 'Advert'}`}
                    positiveTitle={'Delete'}
                    positiveButtonStyle={{ backgroundColor: '#D13536', color: 'white', borderRadius: 20, width: 'auto', border: '1px solid #D13536' }}
                    positivePress={() => handleDelete()}
                    cancelButton={true}
                    width={'40%'}
                    windowWidth={width}
                >
                    <div className="subheader-2">Are you sure to want to delete this {advertDetails?.status === 'draft' ? 'draft' : 'advert'}?</div>
                </AppDialog>
                <PublishAdvert
                    open={publishOpen}
                    close={() => setPublishOpen(false)}
                    handleSubmit={() => { handlePublish() }}
                    windowWidth={width}
                    isDirectSeller={isDirectSeller}
                />
                <MarkSold
                    open={soldOpen}
                    close={() => setSoldOpen(false)}
                    handleSubmit={() => { handleMarkAsSold() }}
                    windowWidth={width}
                />
                <MoveToHidden
                    open={moveToHiddenOpen}
                    close={() => setMoveToHiddenOpen(false)}
                    handleSubmit={() => { handleMoveToHidden() }}
                    windowWidth={width}
                />
                <MarkReserved
                    open={reservedOpen}
                    close={() => setReservedOpen(false)}
                    handleSubmit={() => { handleMarkAsReserved() }}
                    windowWidth={width}
                />
                <ReactivateAlert
                    open={reactivateAlertOpen}
                    close={() => setReactivateAlertOpen(false)}
                    handleSubmit={() => { handleReactivateAlert() }}
                    windowWidth={width}
                />
                <BoostAdvert
                    open={boostOpen}
                    close={() => setBoostOpen(false)}
                    handleSubmit={() => { handleBoostAdvert() }}
                    advertData={advertDetails}
                    userCreditBalance={userCreditBalance}
                    windowWidth={width}
                    setRenewOpen={setRenewOpen}
                />
                <AppealModal
                    open={appealOpen}
                    close={() => setAppealOpen(false)}
                    handleSubmit={() => { handleAppeal() }}
                    windowWidth={width}
                />
                <RenewAdvert
                    open={renewOpen}
                    close={() => setRenewOpen(false)}
                    handleSubmit={() => { handleRenewAdvert() }}
                    advertDetails={advertDetails}
                    windowWidth={width}
                />
                <MoveDraft
                    open={moveDraftOpen}
                    close={() => setMoveDraftOpen(false)}
                    handleSubmit={() => { handleMoveToDraft() }}
                    windowWidth={width}
                />
                <RevertStatus
                    open={revertOpen}
                    close={() => setRevertOpen(false)}
                    handleSubmit={() => { handleRevertStatus() }}
                    windowWidth={width}
                    revertStatus={revertStatus}
                />
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Advert, General, Layout }) {
    return {
        userData: Login?.verifyAdmin?.user?.data,
        isDirectSeller: Login?.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,
        userCreditBalance: Login?.verifyAdmin?.user?.data?.profile?.credit_balance,
        userPermission: Login?.permissionArry,
        advertDetails: Advert?.advertDetails?.data,
        advertDetailsCode: Advert?.advertDetails,
        error: Advert?.error?.errors,
        editAdvert: Advert?.advertEdit,
        advertDelete: Advert?.advertDelete,
        advertInquiryListing: Advert?.advertInquiryListing?.data,
        advertRemarkListing: Advert?.advertRemarkListing?.data,
        sentEmail: General?.send_email_response,
        leftSideBarType: Layout.leftSideBarType,
        width: Layout.currentWidth,
        makeList: General.bike_makes,
        modelList: General.bike_models,
        bodyList: General.bike_types,
        licenseCategoryList: General.license_categories,
        salesmanList: General.dealer_salesmans,
        transmissionList: General.transmissions,
    };
}


export default connect(mapStateToProps)(AdvertDetails);
